import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateGradingScales = () => {
  return (
    <Create
      title="Нова скала за оценяване"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        defaultValues={{
          gradeThresholds: [{ minPoints: 0, grade: 2 }, {}],
        }}
      >
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateGradingScales;
